import { useQuery } from '@tanstack/react-query';
import { sortBy } from 'lodash';

import { getSankeyTitle } from 'diagram/title';
import { sankeyToForm } from 'utils/form';

import { useApiContext } from './contexts/apiContext';
import { useCurrentUser } from './utils/user';

/*
 * Queries and mutations
 */

export const useCurrentUserQuery = () => {
  const { api } = useApiContext();

  return useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      try {
        return (await api().currentUser.retrieve()).data;
      } catch (error) {
        throw Error('Error fetching current user');
      }
    },
  });
};

export const useTeamSankeysQuery = () => {
  const { api } = useApiContext();
  const { user } = useCurrentUser();

  const teamId = user?.default_team?.id;

  return useQuery({
    queryKey: ['team-sankeys'],
    queryFn: async () => {
      try {
        const { data } = await api().sankeys.list({ teamId });
        return sortBy(data, 'created_at').reverse();
      } catch (error) {
        throw Error(`Error fetching team Sankeys`);
      }
    },
    enabled: !!user,
  });
};

export const useTemplateSankeysWithSVGQuery = (enabled: boolean) => {
  const { api } = useApiContext();

  return useQuery({
    queryKey: ['template-sankeys-with-svg'],
    queryFn: async () => {
      try {
        const { data } = await api().sankeys.list(
          { isTemplate: true },
          {
            params: { simple: false },
          }
        );
        // Sort templates by their name but always put income templates first (like Django does in get_template_sankeys)
        return sortBy(data, (template) => {
          const priority = template.statement_type === 'income' ? 0 : 1;
          return `${priority}-${getSankeyTitle(sankeyToForm(template))}`;
        });
      } catch (error) {
        throw Error('Error fetching template Sankeys');
      }
    },
    enabled,
  });
};
